/**************************************************LIBARY IMPORTS******************************************************/
import React, { useEffect, useState, useContext, useMemo } from 'react';
import DOMPurify from 'dompurify';
import { Button, Form, Image, Modal } from 'react-bootstrap';
import {
  evaluateVisibility,
  finishLastStep,
  saveFileServer,
  settingDefaultValues,
  validateOnChangeValues,
  isImage,
  iconUrl,
  iconUrlByExt,
} from './dynamic_form_logic';
import LoaderContext from '../layout/shared/loader_context';
import { Col, Grid, Row } from 'react-flexbox-grid';
import DynamicMap from '../helper_components/dynamic_map/DynamicMap';
import DynamicSelect from '../helper_components/dynamic_select/DynamicSelect';
import Cookies from 'js-cookie';
import _ from 'lodash';
import ObservationModal from './observations/ObservationsModal';
/************************************************************************************************************************/
import DigitalSignature from '../helper_components/digital_signature/DigitalSignature';
import DigitalDocument from '../helper_components/digital_document/DigitalDocument';
import DatePicker from '../helper_components/date_picker/DatePicker';
import Muuri from '../muuri/Muuri';
import GridField from '../helper_components/grid/GridField';
import DynamicFormFileType from './dynamic_form_types/DynamicFormFileType';
import { updateAllAlertNotifications } from '../alertNotificationTable/alert_notification_logic';
import NotificationAlertListContext from '../alertNotificationTable/notification_alert_context';

const DynamicForm = (props) => {
  const [state, setState] = useState({});
  const [dataForm, setDataForm] = useState([]);
  const [buttonToDisabled, setButtonToDisabled] = useState('');
  const [previousUrl, setPreviousUrl] = useState('');
  const [observationModal, setObservationModal] = useState(false);
  const [previewFileImage, setPreviewFileImage] = useState(false);
  const [previewFileImgUrl, setPreviewImgUrl] = useState('');
  const [activeElementValidable, setActiveElementValidable] = useState({});
  const [disableUploadButton, setDisableUploadButton] = useState(false);
  const [nextButtonDisable, setNextButtonDisable] = useState(false);
  const [action, setAction] = useState('');
  const alertContext = useContext(NotificationAlertListContext);
  const loader = useContext(LoaderContext);
  const [showErrorTextIfIsNotSigned, setShowErrorTextIfIsNotSigned] = useState(false);

  const formsWithElectronicSignatureList = useMemo(() => {
    if (!(props && props.form && Array.isArray(props.form))) {
      return [];
    }
    return props.form.filter(
      (formItem) =>
        formItem.extra_attributes &&
        formItem.extra_attributes.sign &&
        formItem.extra_attributes.sign === 'si'
    );
  }, [props.form]);

  const [currentFormElectronicSignatureToEdit, setCurrentFormElectronicSignatureToEdit] = useState(
    (formsWithElectronicSignatureList[0] && formsWithElectronicSignatureList[0].name) || ''
  );

  const enableNextFormElectronicSignature = () => {
    const formElectronicSignatureNoCredentials = formsWithElectronicSignatureList.find(
      (electronicSignatureItem) =>
        typeof state[electronicSignatureItem.name] === 'string' &&
        electronicSignatureItem.name !== currentFormElectronicSignatureToEdit
    );
    const _currentFormElectronicSignatureToEdit =
      formElectronicSignatureNoCredentials && formElectronicSignatureNoCredentials.name
        ? formElectronicSignatureNoCredentials.name
        : '';
    setCurrentFormElectronicSignatureToEdit(_currentFormElectronicSignatureToEdit);
  };

  useEffect(() => {
    setCurrentFormElectronicSignatureToEdit(
      (formsWithElectronicSignatureList[0] && formsWithElectronicSignatureList[0].name) || ''
    );
  }, [formsWithElectronicSignatureList]);

  useEffect(() => {
    //ORDENAMOS EL FORMULARIO POR LA POSISION Y DEL FORMULARIO
    setPreviousUrl(props.previousUrl);
    const formsSort = props.form;
    let defaultValuesFormInit = {};
    setNextButtonDisable(false);

    if (!props.hasErrors) {
      setNextButtonDisable(false);
      defaultValuesFormInit = settingDefaultValues(formsSort, setNextButtonDisable, props.mode);
      setState(defaultValuesFormInit);
    }

    // check visibility fields
    const formEvaluated = evaluateVisibility(formsSort, defaultValuesFormInit, null, null, null);
    //GUARDAMOS EN EL STATE EL VALOR DEL FORMULARIO QUE PASAMOS COMO PROP
    if (formEvaluated.length > 0) {
      setDataForm(formEvaluated);
    }
  }, [props.form, dataForm]);

  const checkForUnsignedItems = () => {
    let electronicSignatureNameItems = [];
    const areFormFieldsRequired = Number(props.mode) !== 2;

    if (!areFormFieldsRequired) {
      return false;
    }

    if (dataForm.length > 0) {
      const signatureItems = dataForm.filter(
        (item) =>
          item.extra_attributes &&
          item.extra_attributes.sign === 'si' &&
          Number(item.readonly) === 0
      );
      electronicSignatureNameItems = signatureItems.map((item) => item.name);
    }

    if (electronicSignatureNameItems.length > 0) {
      const signedElements = electronicSignatureNameItems.filter(
        (SignatureItem) => state[SignatureItem].FileName
      );
      return signedElements.length !== electronicSignatureNameItems.length;
    }
    return false;
  };

  //CUANDO LE DA CLICK EN CONTINUAR
  const onSubmit = (e) => {
    e.preventDefault();
    if (props.onSubmit) {
      setAction('SUBMIT');
      props.onSubmit(state);
    }
  };

  //CUANDO EL USUARIO LE DA CLICK EN GUARDAR
  const onSaveHandler = (e) => {
    //Request para el siguiente formulario
    e.preventDefault();
    if (props.onSubmit) {
      setAction('SAVE');
      props.onSubmit(state, true);
    }
  };

  //CUANDO LE DA CLICK EN ANTERIOR
  const onPreviousHandler = (e) => {
    e.preventDefault();
    if (previousUrl) {
      setAction('PREVIOUS');
      setState({});
      props.setLastStep(false);
      props.setHasErrors(false);
      props.previousUrlHandler(previousUrl);
    }
  };

  const onChangeListCheckboxHandler = (event, checkbox, element) => {
    let nameCheckboxSelected = '';
    let valueCheckboxSelected = false;
    const newListCheckbox = state[element.name];
    const nameState = element.name;
    newListCheckbox.forEach((check) => {
      if (typeof check[checkbox.name] !== 'undefined') {
        nameCheckboxSelected = event.target.name;
        valueCheckboxSelected = event.target.checked;
        check[checkbox.name] = event.target.checked;
      }
    });
    setState({ ...state, [nameState]: newListCheckbox });
    evaluateVisibility(
      dataForm,
      state,
      valueCheckboxSelected,
      nameCheckboxSelected,
      'checkbox-list',
      element.name
    );
  };

  const onChangeHandler = (e, key, type = null, errorDate = null) => {
    const valueInput = e;
    const elementName = key;
    const elementType = type;
    const elementErrorDate = errorDate;
    validateOnChangeValues(
      valueInput,
      elementName,
      elementType,
      elementErrorDate,
      state,
      setState,
      dataForm,
      setDataForm
    );
  };

  // Helper to clear forced inline styles applied via ref when user types
  const clearForcedStyles = (input) => {
    if (!input) return;
    try {
      input.style.removeProperty('border');
      input.style.removeProperty('box-shadow');
    } catch (e) {
      /* ignore */
    }
    // also remove is-invalid class if present to let CSS reflect current validation
    if (input.classList && input.classList.contains('is-invalid')) {
      input.classList.remove('is-invalid');
    }
  };

  const onObservationClickHandler = async (el) => {
    setActiveElementValidable(el);
    setObservationModal(true);
  };

  //CUANDO DAN CLICK AL BOTON DE CONFIRMAR EN EL ULTIMO FORMULARIO
  const finishStage = async () => {
    setAction('END');
    loader.show(true);
    const { userId_03 } = Cookies.get();
    const stage_id = props.stage;
    setButtonToDisabled('finish');
    await finishLastStep(stage_id, userId_03, state.next_user, props);
    loader.show(false);
    await updateAllAlertNotifications(alertContext);
  };

  const setErrorByElement = (el) => {
    const errorMessages = el.error
      ? el.error.map((el, index) => {
          return (
            <li key={index} style={{ listStyleType: 'none', paddingLeft: 0 }}>
              <p className="text-danger">{el}</p>
            </li>
          );
        })
      : '';
    return errorMessages;
  };

  const createInputBaseTypeForm = (el) => {
    const disableFieldBasedMethod = (el) => {
      const { userId_03 } = Cookies.get();

      if (!el.readonly || el.readonly === 0) {
        if (props.mode === 2) {
          return true;
        }
        if (props.mode === 1) {
          return false;
        } else {
          if (parseInt(userId_03) !== parseInt(props.applicant)) {
            return true;
          } else {
            if (el.observations) {
              return false;
            } else {
              return true;
            }
          }
        }
      }
      if (el.readonly === 1) {
        if (props.mode === 2) {
          return true;
        }
        if (props.mode === 1) {
          return true;
        } else {
          if (parseInt(userId_03) !== parseInt(props.applicant)) {
            return true;
          } else {
            if (el.observations) {
              return false;
            } else {
              return true;
            }
          }
        }
      }
    };

    const onDrop = async (acceptedFiles, el) => {
      if (!disableUploadButton) {
        let file = acceptedFiles[0];
        const reader = new FileReader();
        setDisableUploadButton(true);

        reader.onload = async (event) => {
          setState({ ...state, [el.name + '_status']: 1 });

          const fileSaved = await saveFileServer(
            event.target.result,
            props.history.location.state.params.stage,
            el
          );

          if (fileSaved) {
            setState({
              ...state,
              [el.name]: fileSaved.key,
              [el.name + '_img']: fileSaved.url,
              [el.name + '_ext']: fileSaved.extension,
              [el.name + '_loader']: false,
              [el.name + '_status']: 2,
            });
          } else {
            setTimeout(() => {
              setState({ [el.name + '_status']: 0 });
            }, 700);
          }

          setDisableUploadButton(false);
        };

        reader.readAsDataURL(file);
      }
    };

    const previewFileImgHandler = (state, el) => {
      // La URL de watermark llega firmada desde el backend; se usa tal cual.
      setPreviewImgUrl(state[el.name + '_img']);
      setPreviewFileImage(true);
    };

    switch (el.type) {
      case 'text':
        const errorsInputText = setErrorByElement(el);
        return (
          <>
            <Col className={'' + (el.visibility['status'] ? '' : ' d-none')} xs={12} md={el.width}>
              <Form.Group controlId={`inputForm.${el.name}`}>
                <Form.Label
                  className={'font-weight-bold '}
                  style={{ color: !el.error ? '#333333' : '', fontSize: '16px' }}
                >
                  <span style={el.requiredSignal ? { display: 'inline' } : { display: 'none' }}>
                    <b>* </b>
                  </span>
                  {el.label}
                  <span
                    className="observation-input-icon"
                    style={{
                      display: el.is_validable && props.mode === 3 ? 'inline-block' : 'none',
                    }}
                    onClick={() => onObservationClickHandler(el)}
                  >
                    <i className={'far fa-comment-dots'} />
                  </span>
                </Form.Label>
                <Form.Control
                  type={el.type}
                  disabled={disableFieldBasedMethod(el)}
                  name={el.name}
                  key={el.id}
                  onChange={(e) => {
                    // clear inline forced styles when user types
                    clearForcedStyles(e.target);
                    onChangeHandler(e, el.name);
                  }}
                  value={state[el.name] || ''}
                  className={el.error ? 'is-invalid' : ''}
                  style={{
                    backgroundColor: disableFieldBasedMethod(el) ? '#cef0ff' : undefined,
                    color: '#333333',
                  }}
                  ref={(input) => {
                    if (input && el && el.error && !state[el.name]) {
                      try {
                        input.style.setProperty('border', '2px solid #ff0000', 'important');
                        input.style.setProperty('box-shadow', 'none', 'important');
                      } catch (e) {
                        /* ignore */
                      }
                    }
                  }}
                />
                {el.error && errorsInputText && !state[el.name] ? (
                  <div className="invalid-feedback d-block" style={{ fontSize: '16px' }}>
                    {errorsInputText}
                  </div>
                ) : null}
                <Form.Text className="" style={{ fontSize: '16px', color: '#333333' }}>
                  {el.contextual_help ? el.contextual_help : ''}
                </Form.Text>
              </Form.Group>
            </Col>
          </>
        );
      case 'title':
        return (
          <>
            <Col className={'' + (el.visibility['status'] ? '' : ' d-none')} xs={12} md={el.width}>
              {
                // SINO TRAE ESTOS ELEMENTOS SIGNIFICA QUE ES EL MENSAJE DE QUE SE HA FINALIZADO LA ETAPA
                el.id !== '' && el.form_id !== '' ? (
                  <h1 key={el.id} id={el.id} style={{ color: '#333333', fontSize: '16px' }}>
                    {el.label}
                  </h1>
                ) : (
                  // Y ENTONCES DEBEMOS DE PINTAR LOS ESTILOS DEL HTML CONFIGURADOS CON TINYMCE
                  <div
                    style={{
                      boxShadow: '0px 2px 2px 2px #EEEEEE',
                      padding: '20px',
                      borderRadius: '20px',
                      marginBottom: '3rem',
                      color: '#333333',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(el.label),
                    }}
                    id={el.id}
                  ></div>
                )
              }
            </Col>
          </>
        );
      case 'textarea':
        const errorsTextArea = setErrorByElement(el);
        const textareaHeight = el.height * 0.79 + 'rem';
        return (
          <Col
            className={'h-100 mb-0' + (el.visibility['status'] ? '' : ' d-none')}
            xs={12}
            md={el.width}
          >
            <Form.Group controlId={`inputForm.${el.name}`}>
              <Form.Label
                className={'font-weight-bold '}
                style={{ color: !el.error ? '#333333' : '', fontSize: '16px' }}
              >
                <span style={el.requiredSignal ? { display: 'inline' } : { display: 'none' }}>
                  <b>* </b>
                </span>
                {el.label}
                <span
                  className="observation-input-icon"
                  style={{
                    display: el.is_validable && props.mode === 3 ? 'inline-block' : 'none',
                  }}
                  onClick={() => onObservationClickHandler(el)}
                >
                  <i className={'far fa-comment-dots' + (el.observations ? ' text-danger' : '')} />
                </span>
              </Form.Label>
              <Form.Control
                as={el.type}
                rows="3"
                name={el.name}
                disabled={disableFieldBasedMethod(el)}
                key={el.id}
                onChange={(e) => {
                  clearForcedStyles(e.target);
                  onChangeHandler(e, el.name);
                }}
                value={state[el.name] || ''}
                className={el.error ? 'is-invalid' : ''}
                style={{
                  height: textareaHeight,
                  resize: 'none',
                  color: '#333333',
                  backgroundColor: disableFieldBasedMethod(el) ? '#cef0ff' : undefined,
                }}
                ref={(input) => {
                  if (input && el && el.error && !state[el.name]) {
                    try {
                      input.style.setProperty('border', '2px solid #ff0000', 'important');
                      input.style.setProperty('box-shadow', 'none', 'important');
                    } catch (e) {
                      /* ignore */
                    }
                  }
                }}
              />
              {el.error && errorsTextArea && !state[el.name] ? (
                <div className="invalid-feedback d-block" style={{ fontSize: '16px' }}>
                  {errorsTextArea}
                </div>
              ) : null}
              <Form.Text className="" style={{ fontSize: '16px', color: '#333333' }}>
                {el.contextual_help ? el.contextual_help : ''}
              </Form.Text>
            </Form.Group>
          </Col>
        );
      case 'check-box':
        const errorsCheckbox = setErrorByElement(el);
        const isMultipleCheckbox = _.has(el.extra_attributes, 'check');
        //SI ES UN CHECK-BOX PERO ES UNA LISTA DE CHECKBOX
        if (isMultipleCheckbox) {
          let checks = {};
          const list = el.extra_attributes.check.map((element, index) => {
            (state[el.name] ? state[el.name] : []).find((check) => {
              checks = { ...checks, ...check };
            });

            return (
              <div className="form-check" key={index}>
                <input
                  type="checkbox"
                  className={element.error ? 'form-check-input is-invalid' : 'form-check-input'}
                  disabled={disableFieldBasedMethod(el)}
                  id={element.name}
                  key={element.id}
                  name={element.name}
                  checked={checks[element.name]}
                  onChange={(event) => onChangeListCheckboxHandler(event, element, el)}
                  style={{ cursor: disableFieldBasedMethod(el) ? 'not-allowed' : 'pointer' }}
                />
                <label
                  className={el.error ? 'form-check-label text-danger' : 'form-check-label'}
                  htmlFor={element.name}
                  style={{ color: !el.error ? '#333333' : '' }}
                >
                  {element.label}
                </label>
              </div>
            );
          });
          return (
            <Col className={el.visibility['status'] ? 'p-10' : 'p-10 d-none'} xs={12} md={el.width}>
              <Form.Group controlId={`inputForm.${el.name}`}>
                <Col xs={12}>
                  <Form.Label
                    className={
                      'font-weight-bold ' +
                      (el.error ? 'form-check-label text-danger' : 'form-check-label')
                    }
                    htmlFor={`${el.name}_checkboxlist_label`}
                    style={{
                      color: !el.error ? '#333333' : '',
                      fontSize: '16px',
                      marginBottom: '8px',
                    }}
                  >
                    <span style={el.requiredSignal ? { display: 'inline' } : { display: 'none' }}>
                      <b>* </b>
                    </span>
                    {el.label}
                    <span
                      className="observation-input-icon"
                      style={{
                        display: el.is_validable && props.mode === 3 ? 'inline-block' : 'none',
                      }}
                      onClick={() => onObservationClickHandler(el)}
                    >
                      <i
                        className={'far fa-comment-dots' + (el.observations ? ' text-danger' : '')}
                      />
                    </span>
                  </Form.Label>
                </Col>

                <Col xs={12} sm={12}>
                  {list}
                </Col>
                <Col xs={12} sm={12}>
                  <small
                    id={`small${el.name}`}
                    className="form-text mt-1"
                    style={{ fontSize: '16px', color: '#333333' }}
                  >
                    {el.contextual_help ? el.contextual_help : ''}
                  </small>
                </Col>
                {errorsCheckbox}
              </Form.Group>
            </Col>
          );
        } else {
          //SI ES UN CHECK-BOX SINGULAR, SOLAMENTE UN CAMPO DECLARADO EN EL MODELADO
          return (
            <Col
              xs={12}
              md={el.width}
              className={
                'form-group row p-2 pt-4 h-100 mb-0' + (el.visibility['status'] ? '' : ' d-none')
              }
            >
              <Col xs={12}>
                <div className="col-sm-10">
                  <Form.Group controlId={`inputForm.${el.name}`}>
                    <Form.Label
                      className="font-weight-bold form-check-label"
                      htmlFor={`${el.name}_checkbox_label`}
                      style={{
                        color: !el.error ? '#333333' : '',
                        fontSize: '16px',
                        marginBottom: '8px',
                      }}
                    >
                      <span style={el.requiredSignal ? { display: 'inline' } : { display: 'none' }}>
                        <b>* </b>
                      </span>
                      {el.label}
                      <span
                        className="observation-input-icon"
                        style={{
                          display: el.is_validable && props.mode === 3 ? 'inline-block' : 'none',
                        }}
                        onClick={() => onObservationClickHandler(el)}
                      >
                        <i
                          className={
                            'far fa-comment-dots' + (el.observations ? ' text-danger' : '')
                          }
                        />
                      </span>
                    </Form.Label>
                    <div className="form-check">
                      <input
                        className={el.error ? 'form-check-input is-invalid' : 'form-check-input'}
                        type="checkbox"
                        disabled={disableFieldBasedMethod(el)}
                        id={el.name}
                        key={el.id}
                        name={el.name}
                        checked={state[el.name] || false}
                        onChange={(e) => onChangeHandler(e, el.name, el.type)}
                        required
                        style={{ cursor: disableFieldBasedMethod(el) ? 'not-allowed' : 'pointer' }}
                      />
                      <label
                        className={el.error ? 'form-check-label text-danger' : 'form-check-label'}
                        htmlFor={el.name}
                        style={{ color: !el.error ? '#333333' : '' }}
                      >
                        {el.label}
                      </label>
                    </div>
                    <small
                      id={`small${el.name}`}
                      className="form-text"
                      style={{ fontSize: '16px', color: '#333333' }}
                    >
                      {el.contextual_help ? el.contextual_help : ''}
                    </small>
                    {errorsCheckbox}
                  </Form.Group>
                </div>
              </Col>
            </Col>
          );
        }

      case 'subtitle':
        return (
          <Col
            xs={12}
            md={el.width}
            className={'' + (el.visibility['status'] ? '' : ' d-none')}
            style={{ color: '#333333' }}
          >
            <h2 key={el.id} id={el.id} style={{ color: '#333333', fontSize: '12px' }}>
              {el.label}
            </h2>
          </Col>
        );

      case 'radio-button':
        const errorsRadio = setErrorByElement(el);
        return (
          <Col xs={12} className={'' + (el.visibility['status'] ? '' : ' d-none')}>
            <Form.Group controlId={`inputForm.${el.name}`}>
              <div>
                <label className="font-weight-bold" style={{ color: '#333333', fontSize: '16px' }}>
                  <span style={el.requiredSignal ? { display: 'inline' } : { display: 'none' }}>
                    <b>* </b>
                  </span>
                  {el.label}
                </label>

                <span
                  className="observation-input-icon"
                  style={{
                    display: el.is_validable && props.mode === 3 ? 'inline-block' : 'none',
                  }}
                  onClick={() => onObservationClickHandler(el)}
                >
                  <i className={'far fa-comment-dots' + (el.observations ? ' text-danger' : '')} />
                </span>
              </div>

              {el.extra_attributes.options.map((option, index) => {
                return (
                  <Col xs={12} md={el.width} key={index}>
                    <div className="form-check">
                      <input
                        className={el.error ? 'form-check-input is-invalid' : 'form-check-input'}
                        disabled={disableFieldBasedMethod(el)}
                        type="radio"
                        name={el.name}
                        id={`${option.label}-radio`}
                        checked={option.value === state[el.name] ? true : false}
                        onChange={(e) => onChangeHandler(e, el.name, el.type, option.value)}
                        style={{ cursor: disableFieldBasedMethod(el) ? 'not-allowed' : 'pointer' }}
                      />
                      <label
                        className={el.error ? 'form-check-label text-danger' : 'form-check-label'}
                        htmlFor={`${option.label}-radio`}
                        style={{ color: !el.error ? '#333333' : '' }}
                      >
                        {option.label}
                      </label>
                    </div>
                  </Col>
                );
              })}

              <small
                id={`small${el.name}`}
                className="form-text mt-1"
                style={{ fontSize: '16px', color: '#333333' }}
              >
                {el.contextual_help ? el.contextual_help : ''}
              </small>
              {errorsRadio}
            </Form.Group>
          </Col>
        );

      case 'paragraph':
        return (
          <>
            <Col
              className={
                'h-100 mb-0 mT-10 overflow-auto paragraph-wrapper' +
                (el.visibility['status'] ? '' : ' d-none')
              }
              xs={12}
              md={el.width}
            >
              <label className="font-weight-bold" style={{ color: '#333333' }}>
                {el.label}
              </label>
              <p
                className="break-word overflow-y-scroll"
                style={{ color: '#333333' }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(el.extra_attributes.content),
                }}
              />
            </Col>
          </>
        );

      case 'redirect':
        return (
          <>
            <Col className={el.visibility['status'] ? '' : ' d-none'} xs={12} md={el.width}>
              <label className="font-weight-bold" style={{ color: '#333333' }}>
                {el.label}
              </label>
              <div>
                <Button>
                  <a
                    href={el.extra_attributes.url}
                    target={el.extra_attributes.target}
                    style={{ color: 'white', textDecoration: 'none' }}
                  >
                    {el.extra_attributes.url_label}
                  </a>
                </Button>
              </div>
              <div className="w-100">
                <small
                  id="redirectHelp"
                  className="form-text "
                  style={{ fontSize: '16px', color: '#333333' }}
                >
                  {el.contextual_help ? el.contextual_help : ''}
                </small>
              </div>
            </Col>
          </>
        );

      case 'hidden':
        return (
          <>
            <Form.Group controlId={`inputForm.${el.name}`}>
              <Form.Control
                type="text"
                name={el.name}
                key={el.id}
                value={el.default_value ? el.default_value : ''}
                onChange={() => {}}
                style={{ visibility: 'hidden' }}
              />
            </Form.Group>
          </>
        );

      case 'file':
        const porpsDynamicFormFileType = {
          el,
          onObservationClickHandler,
          disableFieldBasedMethod,
          onChangeHandler,
          props,
          state,
          setState,
          isImage,
          iconUrl,
          iconUrlByExt,
          onDrop,
          disableUploadButton,
          previewFileImgHandler,
          showErrorTextIfIsNotSigned,
          isEditingEnabledInFormElectronicSignature:
            currentFormElectronicSignatureToEdit === el.name,
          setCurrentFormElectronicSignatureToEdit,
          enableNextFormElectronicSignature,
        };

        return <DynamicFormFileType {...porpsDynamicFormFileType} />;
      case 'date':
        const errorsCalendar = setErrorByElement(el);
        return (
          <DatePicker
            el={el}
            hasErrors={el.error}
            errorsCalendar={errorsCalendar}
            onChangeHandler={onChangeHandler}
            state={state}
            setState={setState}
            mode={props.mode}
            setShow={onObservationClickHandler}
            show={observationModal}
            applicant={props.applicant}
          />
        );

      case 'map':
        const errorsMap = setErrorByElement(el);

        if (el.visibility.status)
          return (
            <DynamicMap
              el={el}
              onChangeHandler={onChangeHandler}
              hasErrors={el.error}
              errorsMap={errorsMap}
              state={state}
              setState={setState}
              mode={props.mode}
              setShow={onObservationClickHandler}
              show={observationModal}
              applicant={props.applicant}
            />
          );
        break;

      case 'select':
        const errorSelect = setErrorByElement(el);
        return (
          <DynamicSelect
            el={el}
            onChangeHandler={onChangeHandler}
            hasErrors={el.error}
            errorSelect={errorSelect}
            state={state}
            setState={setState}
            mode={props.mode}
            setShow={onObservationClickHandler}
            show={observationModal}
            applicant={props.applicant}
          />
        );

      case 'digital-signature':
        const errorDigital = setErrorByElement(el);
        return (
          <DigitalSignature
            el={el}
            onChangeHandler={onChangeHandler}
            hasErrors={el.error}
            errorDigital={errorDigital}
            state={state}
            setState={setState}
            mode={props.mode}
            stage={props.stage}
            showModalSignature=""
            showDowloadDocument=""
            finalDocumentUrlPDF=""
            setFinalDocumentUrlPDF=""
            setSignInStep=""
          />
        );

      case 'digital-document':
        const errorDocument = setErrorByElement(el);
        return (
          <DigitalDocument
            el={el}
            onChangeHandler={onChangeHandler}
            hasErrors={el.error}
            errorDocument={errorDocument}
            state={state}
            setState={setState}
            mode={props.mode}
            stage={props.stage}
            setNextButtonDisable={setNextButtonDisable}
          />
        );

      case 'grid':
        return (
          <GridField
            el={el}
            onChangeHandler={onChangeHandler}
            state={state}
            setState={setState}
            mode={props.mode}
            stage={props.stage}
            setNextButtonDisable={setNextButtonDisable}
          />
        );

      default:
        break;
    }
  };

  const buttonToolbar = () => {
    if (!props.lastStep) {
      if (!props.previousUrl) {
        return (
          <Grid className="mT-20 dynamic-form-toolbar container">
            <Row>
              <div className="p-100 w-100">
                <span className="form-text text-center">
                  <b>( * ) Campos requeridos.</b>
                </span>
              </div>
              <Col xs={12} md={12}>
                <Button
                  variant="dark"
                  type="button"
                  onClick={() => props.history.push('/table_process/pending')}
                >
                  Cancelar
                </Button>
                <Button
                  variant="success"
                  type="button"
                  className={
                    loader.status && action === 'SAVE' ? 'd-n' : 'd-block float-right px-4 mR-20'
                  }
                  onClick={onSubmit}
                  disabled={nextButtonDisable || (loader.status && buttonToDisabled === 'next')}
                >
                  {loader.status && action === 'SUBMIT' ? 'Ejecutando...' : 'Siguiente'}
                </Button>
                <Button
                  variant="primary"
                  type="button"
                  className={
                    loader.status && action === 'SUBMIT' ? 'd-n' : 'd-block float-right px-4 mR-20'
                  }
                  onClick={onSaveHandler}
                >
                  {loader.status && action === 'SAVE' ? 'Guardando...' : 'Guardar'}
                </Button>
              </Col>
            </Row>
          </Grid>
        );
      } else {
        return (
          <Grid className="mT-20 dynamic-form-toolbar container">
            <Row>
              <div className="p-100 w-100">
                <span className="form-text text-center">
                  <b>( * ) Campos requeridos.</b>
                </span>
              </div>
              <Col xs={12} md={12}>
                <Button
                  variant="dark"
                  type="button"
                  className="d-block float-left px-4"
                  onClick={() => props.history.push('/table_process/pending')}
                >
                  Cancelar
                </Button>
                <Button
                  variant="secondary"
                  type="button"
                  className="d-block float-left px-4 mL-20"
                  onClick={onPreviousHandler}
                >
                  {loader.status && action === 'PREVIOUS' ? 'Ejecutando...' : 'Anterior'}
                </Button>
                <Button
                  variant="success"
                  type="button"
                  className={
                    loader.status && action === 'SAVE' ? 'd-n' : 'd-block float-right px-4 mR-20'
                  }
                  onClick={onSubmit}
                  disabled={nextButtonDisable || (loader.status && buttonToDisabled === 'next')}
                >
                  {loader.status && action === 'SUBMIT' ? 'Ejecutando...' : 'Siguiente'}
                </Button>
                <Button
                  variant="primary"
                  type="button"
                  className={
                    loader.status && action === 'SUBMIT' ? 'd-n' : 'd-block float-right px-4 mR-20'
                  }
                  onClick={onSaveHandler}
                >
                  {loader.status && action === 'SAVE' ? 'Guardando...' : 'Guardar'}
                </Button>
              </Col>
            </Row>
          </Grid>
        );
      }
    } else {
      return (
        <Grid className="mT-20 dynamic-form-toolbar container">
          <Row end="xs">
            <Col xs={12} md={12}>
              <Button
                variant="dark"
                type="button"
                className="d-block float-left px-4"
                onClick={() => props.history.push('/table_process/pending')}
              >
                Cancelar
              </Button>
              <Button
                variant="secondary"
                type="button"
                className="d-block float-left px-4 mL-20"
                onClick={onPreviousHandler}
              >
                {loader.status && action === 'PREVIOUS' ? 'Ejecutando...' : 'Anterior'}
              </Button>
              <Button
                variant="primary"
                type="button"
                className="d-block float-right px-4"
                onClick={finishStage}
              >
                {loader.status && action === 'END' ? 'Finalizando...' : 'Confirmar'}
              </Button>
            </Col>
          </Row>
        </Grid>
      );
    }
  };

  return (
    <>
      <Modal
        size="lg"
        show={previewFileImage}
        onHide={() => setPreviewFileImage(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header className={'bg-complement-3'} closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">Previsualización de imagen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Image src={previewFileImgUrl} fluid />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setPreviewFileImage(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
      <ObservationModal
        show={observationModal}
        setShow={setObservationModal}
        el={activeElementValidable}
        stage={props.history.location.state.params.stage}
      />
      <Row>
        <Col xs={12}>
          <Row>
            <Col xs={12}>
              <h3 className="text-center mB-30 mT-40">{props.formTitle}</h3>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              {dataForm.length > 0 ? (
                <Muuri dataForm={dataForm} createInputBaseTypeForm={createInputBaseTypeForm} />
              ) : (
                ''
              )}
            </Col>
          </Row>
          <Row>
            <Col xs={12}> {buttonToolbar()}</Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default DynamicForm;
